import React, { useState, useEffect } from 'react';
import { Box, Grid, TextField, Button } from '@mui/material';
import 'dayjs/locale/ko'; 
import BaseCodeSelectbox from '../../common/form/selectbox/BaseCodeSelectbox';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'

import { FieldArray, FormikProvider } from 'formik';
import TechMultiFileForm from '../../chancemng/support/TechMultiFileForm';
import SubTitleTemplate from '../../common/template/SubTitleTemplate';

const TechPlanForm = ({ formik, techPlan }) => {
  const [plnStrtDt, setPlnStrtDt] = useState(null);
  const [plnEndDt, setPlnEndDt] = useState(null);

  useEffect(() => {
    if (techPlan) {
      if (techPlan.plnStrtDt) setPlnStrtDt(techPlan.plnStrtDt);
      if (techPlan.plnEndDt) setPlnEndDt(techPlan.plnEndDt);
    }
  }, [techPlan]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          mt: 2,
        }}
      >
        <Button
          type="submit"
          variant="contained"
          disabled={formik.isSubmitting}
        >
          저장
        </Button>
      </Box>
      <SubTitleTemplate title="작업 계획 내역 ">
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ my: 1 }}
        >
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={12}>
              <TextField
                margin="normal"
                required
                variant="outlined"
                fullWidth
                id="plnTitle"
                name="plnTitle"
                label="작업 계획 제목"
                value={formik.values.plnTitle}
                onChange={formik.handleChange}
                error={
                  formik.touched.plnTitle && Boolean(formik.errors.plnTitle)
                }
                helperText={formik.touched.plnTitle && formik.errors.plnTitle}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={3}>
              <BaseCodeSelectbox
                formik={formik}
                filterObject={{
                  blcCd: 'BASE',
                  mlcCd: 'TECH',
                  slcCd: 'PLN_TYP',
                  useYn: 'Y',
                }}
                name="plnTyp"
                label="작업 계획 종류"
                margin="normal"
              />
            </Grid>
            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                <DatePicker
                  label="작업 계획 시작일"
                  format="YYYY-MM-DD"
                  mask={'____-__-__'}
                  id="plnStrtDt"
                  name="plnStrtDt"
                  value={dayjs(plnStrtDt)}
                  onChange={(newValue) => {
                    setPlnStrtDt(dayjs(newValue));
                    onChangeDate(dayjs(newValue), 'plnStrtDt');
                  }}
                  slotProps={{
                    textField: {
                      margin: "normal",
                      variant: "outlined",
                      required: true,
                      fullWidth: true,
                      error:
                        formik.touched.plnStrtDt &&
                        Boolean(formik.errors.plnStrtDt),
                      helperText: formik.touched.plnStrtDt && formik.errors.plnStrtDt,
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                <DatePicker
                  label="작업 계획 종료일"
                  format="YYYY-MM-DD"
                  mask={'____-__-__'}
                  id="plnEndDt"
                  name="plnEndDt"
                  value={dayjs(plnEndDt)}
                  onChange={(newValue) => {
                    setPlnEndDt(dayjs(newValue));
                    onChangeDate(dayjs(newValue), 'plnEndDt');
                  }}
                  slotProps={{
                    textField: {
                      margin: "normal",
                      variant: "outlined",
                      required: true,
                      fullWidth: true,
                      error:
                        formik.touched.plnEndDt &&
                        Boolean(formik.errors.plnEndDt),
                      helperText: formik.touched.plnEndDt && formik.errors.plnEndDt,
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={12}>
              <TextField
                margin="normal"
                required
                variant="outlined"
                fullWidth
                multiline
                rows={5}
                id="plnContext"
                name="plnContext"
                label="작업 계획 내용"
                value={formik.values.plnContext}
                onChange={formik.handleChange}
                error={
                  formik.touched.plnContext && Boolean(formik.errors.plnContext)
                }
                helperText={
                  formik.touched.reqContext && formik.errors.reqContext
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </SubTitleTemplate>
      <SubTitleTemplate title="첨부 서류">
        <FormikProvider value={formik}>
          <FieldArray
            name="files"
            render={(arrayHelpers) => (
              <Box sx={{}}>
                <Box>
                  {formik.values?.files.map((f, index) => {
                    return (
                      <TechMultiFileForm
                        key={index}
                        file={f}
                        index={index}
                        touched={formik.touched}
                        errors={formik.errors}
                        handleChange={formik.handleChange}
                        handleBlur={formik.handleBlur}
                        handleRemove={() => arrayHelpers.remove(index)}
                      />
                    );
                  })}
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    my: 2,
                  }}
                >
                  <Button
                    sx={{ mx: 2 }}
                    color="secondary"
                    variant="outlined"
                    onClick={() =>
                      arrayHelpers.push({ fileDesc: '', file: null })
                    }
                  >
                    파일 추가
                  </Button>
                </Box>
              </Box>
            )}
          ></FieldArray>
        </FormikProvider>
      </SubTitleTemplate>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          mt: 2,
        }}
      >
        <Button
          type="submit"
          variant="contained"
          disabled={formik.isSubmitting}
        >
          저장
        </Button>
      </Box>
    </Box>
  );
};

export default TechPlanForm;
